global.rotatePoint = function(p1, p2, angle) {
    var radians = (Math.PI / 180) * angle,
        cos = Math.cos(radians),
        sin = Math.sin(radians),
        nx = (cos * (p2.x - p1.x)) + (sin * (p2.y - p1.y)) + p1.x,
        ny = (cos * (p2.y - p1.y)) - (sin * (p2.x - p1.x)) + p1.y;
    return {'x': nx, 'y':ny};
}

global.angleBetweenPoints = function(p1, p2) {
    return Math.atan2(p2.y - p1.y, p2.x - p1.x) * 180 / Math.PI;
}
